import Parse from 'parse/dist/parse.min.js';
 export async function  getCurrentUser() {
    const currentUser = await Parse.User.current();
    return currentUser;
}
